import { render, staticRenderFns } from "./GeneralIndicatorsGeneralSection.vue?vue&type=template&id=8c407fae&scoped=true"
import script from "./GeneralIndicatorsGeneralSection.vue?vue&type=script&lang=js"
export * from "./GeneralIndicatorsGeneralSection.vue?vue&type=script&lang=js"
import style0 from "./GeneralIndicatorsGeneralSection.vue?vue&type=style&index=0&id=8c407fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c407fae",
  null
  
)

export default component.exports